var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"overflow":"hidden","height":"900px","width":"100%"},attrs:{"frameborder":"0","src":(_vm.axiosBaseURL + "/hangfire?access_token=" + _vm.accToken)}})}
var staticRenderFns = []

export { render, staticRenderFns }